export default "__VITE_ASSET__CvX7Kd1J__"